///
/// EarthBrowser
///
/// Created by Matt Giger on 9/19/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Depth limits for the free/paid tiers (breadth free, depth paid — see
/// documentation/monetization/SUBSCRIPTION_PRICING_MODEL.md). Kept in a
/// dependency-free module so engine code (Clock) can import them without
/// pulling in the redux/RTK-query graph that hooks/useEntitlements needs.
///
/// Paid forecast depth matches the ECMWF ingest: 240h (10 days) on 00Z/12Z
/// runs, 144h (6 days) on 06Z/18Z runs (weather-services/index.ts).
///

export const cFreeForecastDays = 3
export const cPaidForecastDays = 10
export const cFreeHistoryHours = 2
export const cPaidHistoryHours = 48
